module.exports = __webpack_public_path__ + "img/img04.6b0a4d5e.png";